import { render, staticRenderFns } from "./Collect.vue?vue&type=template&id=1993f323&scoped=true"
import script from "./Collect.vue?vue&type=script&lang=js"
export * from "./Collect.vue?vue&type=script&lang=js"
import style0 from "./Collect.vue?vue&type=style&index=0&id=1993f323&prod&scoped=true&lang=css"
import style1 from "./Collect.vue?vue&type=style&index=1&id=1993f323&prod&lang=scss&scoped=true"
import style2 from "./Collect.vue?vue&type=style&index=2&id=1993f323&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993f323",
  null
  
)

export default component.exports